import ContentDownload from '@fs/zion-icon/dist/cjs/icons/ContentDownload'
import { Button, colors } from '@fs/zion-ui'
import React from 'react'

const DownloadCategoryButton = ({ onClick }) => {
  return (
    <Button data-testid="downloadCategoryButton" onClick={onClick}>
      <ContentDownload color={colors.blue30} />
    </Button>
  )
}

export default DownloadCategoryButton
